var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuestion(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8238 4.49246C4.94062 4.16036 5.17121 3.88033 5.47471 3.70196C5.77822 3.52358 6.13506 3.45838 6.48204 3.51789C6.82901 3.57741 7.14373 3.7578 7.37045 4.02712C7.59716 4.29645 7.72125 4.63731 7.72072 4.98936C7.72072 5.98315 6.23002 6.48005 6.23002 6.48005M6.26978 8.46765H6.27474M11.2388 5.98315C11.2388 8.72745 9.01408 10.9521 6.26978 10.9521C3.52548 10.9521 1.30078 8.72745 1.30078 5.98315C1.30078 3.23885 3.52548 1.01416 6.26978 1.01416C9.01408 1.01416 11.2388 3.23885 11.2388 5.98315Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.f20a5ad0396e054f753186674153e0c0.svg";
export { ForwardRef as ReactComponent };